import { render, staticRenderFns } from "./BrandPartial.htm?vue&type=template&id=b76a65ee&scoped=true&external"
import script from "./BrandPartial.js?vue&type=script&lang=js&external"
export * from "./BrandPartial.js?vue&type=script&lang=js&external"
import style0 from "./BrandPartial.scss?vue&type=style&index=0&id=b76a65ee&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76a65ee",
  null
  
)

export default component.exports